import { getFirebaseAuth } from './firebase';

// `online`/`visibility` tự động cho MỌI log client — trước đây phải tự thêm tay từng call site
// (load_guest_lang, load_translated_guide…) mỗi lần gặp lỗi "Load failed" mới không phân biệt được
// "tab đang ở nền/mạng chập chờn" (transient, vô hại) với lỗi code thật; whack-a-mole không hồi kết vì
// có hàng chục call site `logClientError`. Đặt Ở ĐÂY 1 lần — mọi call site tương lai tự có, không cần
// nhớ thêm tay. Caller tự truyền `details.online`/`.visibility` (hiếm) vẫn THẮNG (spread details sau).
function browserDiag(): { online?: boolean; visibility?: string } {
  try {
    return {
      online: typeof navigator !== 'undefined' ? navigator.onLine : undefined,
      visibility: typeof document !== 'undefined' ? document.visibilityState : undefined,
    };
  } catch {
    return {};
  }
}

// Gọi từ catch trong component client khi thao tác Firestore client SDK (getDocs/onSnapshot/
// updateDoc/...) lỗi — bản thân lỗi đó KHÔNG đi qua app/api/ nên logError() (server-only,
// Admin SDK) không tự gọi được. Fire-and-forget: KHÔNG await ở nơi gọi, KHÔNG throw lại lỗi gốc.
export function logClientError(input: {
  route: string;      // vd 'app/(app)/maintenance/page.tsx'
  action?: string;    // vd 'load_blocks'
  message: string;
  details?: Record<string, unknown>;
}): void {
  (async () => {
    try {
      const idToken = await getFirebaseAuth().currentUser?.getIdToken();
      if (!idToken) return;
      await fetch('/api/log-client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({ ...input, details: { ...browserDiag(), ...input.details } }),
      });
    } catch {
      // best-effort — im lặng, không lặp lỗi gốc
    }
  })();
}

// Biến thể cho trang HK deep-link (/hk/[taskId]) — KHÔNG có Firebase Auth, xác thực bằng
// completionToken của task. Đi qua /api/housekeeping/[taskId]/log-client-error.
export function logHkTaskClientError(input: {
  taskId: string;
  completionToken: string;
  route: string;
  action?: string;
  message: string;
  details?: Record<string, unknown>;
}): void {
  (async () => {
    try {
      await fetch(`/api/housekeeping/${input.taskId}/log-client-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ completionToken: input.completionToken, route: input.route, action: input.action, message: input.message, details: { ...browserDiag(), ...input.details } }),
      });
    } catch {
      // best-effort — im lặng, không lặp lỗi gốc
    }
  })();
}

// Biến thể cho trang nhà thầu deep-link (/incident/[incidentId]) — KHÔNG có Firebase Auth,
// xác thực bằng completionToken của incident. Đi qua /api/incidents/[incidentId]/log-client-error.
export function logContractorIncidentClientError(input: {
  incidentId: string;
  completionToken: string;
  route: string;
  action?: string;
  message: string;
  details?: Record<string, unknown>;
}): void {
  (async () => {
    try {
      await fetch(`/api/incidents/${input.incidentId}/log-client-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ completionToken: input.completionToken, route: input.route, action: input.action, message: input.message, details: { ...browserDiag(), ...input.details } }),
      });
    } catch {
      // best-effort — im lặng, không lặp lỗi gốc
    }
  })();
}

// Biến thể cho trang khách công khai (/g) — KHÔNG có Firebase Auth. Đi qua
// /api/portal/[token]/log-client-error (public theo shareToken, giống /lang — có thể gọi cả
// TRƯỚC KHI khách verify xong 4 số, vd lỗi mạng ở chính bước verify()).
export function logPortalClientError(input: {
  token: string;
  route: string;
  action?: string;
  message: string;
  details?: Record<string, unknown>;
}): void {
  (async () => {
    try {
      await fetch(`/api/portal/${input.token}/log-client-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ route: input.route, action: input.action, message: input.message, details: { ...browserDiag(), ...input.details } }),
      });
    } catch {
      // best-effort — im lặng, không lặp lỗi gốc
    }
  })();
}

/** Biến thể cho trang CÔNG KHAI không đăng nhập (/sale, /signup, /hk) — không có idToken nên đi qua
 *  `/api/public/log-client-error` (endpoint tự rate-limit theo IP + allowlist route).
 *  Vẫn fire-and-forget: KHÔNG await, KHÔNG throw lại lỗi gốc. */
export function logPublicClientError(input: { route: string; action?: string; message: string; details?: Record<string, unknown> }): void {
  void fetch('/api/public/log-client-error', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...input, details: { ...browserDiag(), ...input.details } }),
  }).catch(() => { /* best-effort — không lặp lỗi gốc, không có đường nào khác để báo */ });
}
